// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"map_iconSync__33tFg","fa-spin":"map_fa-spin__2jHVC"};